import './HvacFormSectionContent.scss';
import './HvacFormSetupField.scss';
import { FieldPath } from '@form-ts/core';
import React from 'react';
import { DropdownField } from 'src/modules/form/components/DropdownField';
import { FormError } from 'src/modules/form/types/FormError';
import { HvacConfigOption } from 'src/modules/hvac/types/HvacConfig';
import { HvacFormData } from 'src/modules/hvac/types/HvacFormData';

type Props = {
  readonly field: FieldPath<HvacFormData, FormError, HvacConfigOption | null>;
  readonly disabled: boolean;
  readonly readOnly: boolean;
  readonly options: ReadonlyArray<HvacConfigOption>;
  readonly title: string;
  readonly renderOption: (option: HvacConfigOption) => React.ReactElement;
  readonly renderSelectedOption: (option: HvacConfigOption) => React.ReactElement;
};

export const HvacFormSetupField = ({
  field,
  disabled,
  readOnly,
  options,
  title,
  renderOption,
  renderSelectedOption,
}: Props): React.ReactElement => (
  <DropdownField
    size="md"
    label={title}
    disabled={disabled}
    readOnly={readOnly}
    field={field}
    options={options}
    renderSelectedOption={renderSelectedOption}
    renderOption={renderOption}
    getOptionKey={getOptionKey}
    theme="white"
  />
);

function getOptionKey(option: HvacConfigOption): string {
  return option.id;
}
